import { useState } from 'react'
import { StateSetter } from '../Types/Types'

/**
 * This is a useState hook for use within asynchronous functions.
 *
 * @param initialState - The initial variable to set the state to.
 */
export const useStateAsync = <T extends unknown>(
    initialState: T | (() => T)
): [T, StateSetter<T>, () => Promise<T>] => {
    const [state, setState] = useState<T>(initialState)

    // State getter (I don't like doing it this way, but this is how its apparently done)
    // https://medium.com/ableneo/react-setstate-does-not-immediately-update-the-state-84dbd26f67d5
    const getState = async (): Promise<T> =>
        new Promise<T>((resolve): void => {
            setState((currentState: T): T => {
                resolve(currentState)
                return currentState
            })
        })

    return [state, setState, getState]
}
